/**
 * Betlytical modules
 */
import { routes } from '@betlytical/api-schema';

export default [
  ...routes.dealReceipts,
  ...routes.deals,
];
